import { useStore } from '../state/store';
import type { AppMode } from '../state/sep';

const MODES: Array<{ value: AppMode; label: string }> = [
  { value: 'dtf', label: 'DTF' },
  { value: 'sep', label: 'Screen print' },
  { value: 'mockup', label: 'Mockup' },
];

/** Top-bar switch between DTF prep, screen-print separations and garment
 *  mockups. Real buttons (not a select) so the current mode reads at a glance
 *  and any other is one click away. */
export function ModeSwitch() {
  const mode = useStore((s) => s.appMode);
  const setAppMode = useStore((s) => s.setAppMode);
  return (
    <div className="mode-switch" role="group" aria-label="App mode">
      {MODES.map((m) => (
        <button
          key={m.value}
          type="button"
          className={mode === m.value ? 'primary' : ''}
          aria-pressed={mode === m.value}
          onClick={() => setAppMode(m.value)}
        >
          {m.label}
        </button>
      ))}
    </div>
  );
}
